import { Container, Point } from 'pixi.js';
import { MonoBehavior } from './core/monoBehavior';
import lottie, { AnimationItem } from 'lottie-web';
import { Layout } from './LayoutManager';
import { gameContainerId } from '.';

export class SpiderParticles extends MonoBehavior {
    animation?: AnimationItem;
    div: HTMLDivElement;
    constructor(parent: Container) {
        super();
        this.onComplete = this.onComplete.bind(this);
        const pos = new Point();
        parent.getGlobalPosition(pos);
        this.div = document.createElement('div');

        const gameContainer = document.getElementById('game-container');
        const canvasContainer = document.getElementById(gameContainerId);

        if (gameContainer && canvasContainer) {
            const canvasPos = canvasContainer.getBoundingClientRect();
            gameContainer.append(this.div);

            this.div.classList.add('lottie-container');
            const cardSize = Layout.getCardSize();
            const lottieSize = cardSize.height * 3;
            this.div.style.width = lottieSize + 'px';
            this.div.style.height = lottieSize + 'px';

            this.div.style.top = pos.y - lottieSize / 2 + 'px';

            this.div.style.left = pos.x - lottieSize / 2 + 'px';

            this.animation = lottie.loadAnimation({
                container: this.div,
                renderer: 'svg',
                loop: false,
                autoplay: true,

                path: `${window.location.origin}/assets/lottie/spider-web.json`,
            });
            this.animation.addEventListener('complete', this.onComplete);
        }
    }

    onComplete() {
        if (!this.animation) return;
        this.animation.removeEventListener('complete', this.onComplete);
        this.animation.destroy();
        this.div.remove();
    }
}
